import { render } from "./qxc.vue?vue&type=template&id=5f37d8f4&scoped=true"
import script from "./qxc.vue?vue&type=script&lang=js"
export * from "./qxc.vue?vue&type=script&lang=js"

import "./qxc.vue?vue&type=style&index=0&id=5f37d8f4&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f37d8f4"]])

export default __exports__